import React, { useEffect, useState } from "react";
import { getPayLedger } from "../../../services/karkhanaApi";
import { fmtDay, rupees } from "../rates/rateModel";
import { useKT } from "../i18n/kt";

/**
 * Who is owed what today, like the ledger at the back of the sheet: wages due (work done minus
 * paid) and advance still owed, per person and in total. Tap a row for that person's account.
 */
const PayLedger = ({ onPick, between }: { onPick: (p: { id: string; code: string; name: string }) => void; between?: React.ReactNode }) => {
  const { t } = useKT();
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    getPayLedger()
      .then((res: any) => setData(res?.success ? res.data : { people: [] }))
      .catch(() => setData({ people: [] }));
  }, []);

  if (!data) return <div className="kw-empty mt-3">{t("Loading…")}</div>;
  const people: any[] = data.people || [];
  return (
    <>
      <div className="kpay-balances">
        <div className={`kpay-balance${Number(data.wagesDue) > 0 ? " is-due" : ""}`}>
          <span>{t("wages due")}</span>
          <strong>{rupees(data.wagesDue)}</strong>
        </div>
        <div className="kpay-balance">
          <span>{t("advances")}</span>
          <strong>{rupees(data.advanceOutstanding)}</strong>
        </div>
      </div>
      {between}
      {!people.length ? <div className="kw-empty">{t("No work or money recorded yet.")}</div> : null}
      {people.length ? (
        <ul className="kpy-people" aria-label={t("Ledger as of {{day}}", { day: fmtDay(data.asOf) })}>
          {people.map((p) => (
            <li key={p.id}>
              <button type="button" className="kpy-person" onClick={() => onPick({ id: p.id, code: p.code, name: p.name })}>
                <span className="kpy-person__who">
                  <strong>
                    <span className="kw-code">{p.code}</span> {p.name}
                  </strong>
                  <span>
                    {Number(p.advanceOutstanding)
                      ? t("advance {{amount}}", { amount: rupees(p.advanceOutstanding, 0) })
                      : p.lastWorked
                        ? t("last worked {{day}}", { day: fmtDay(p.lastWorked) })
                        : ""}
                  </span>
                </span>
                <span className="kpy-person__amt">
                  {/* The chip sits before the amount so every amount ends on the same right edge. */}
                  {p.issues ? <span className="kd-chip is-warn">{t("rate")}</span> : null}
                  <strong className={Number(p.wagesDue) > 0 ? "is-due" : ""}>{rupees(p.wagesDue, 0)}</strong>
                </span>
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </>
  );
};

export default PayLedger;
